<template>
  <v-container>
    <div class="text-body-1 font-weight-bold pl-5">Commentaire</div>
    <v-divider />
    <v-textarea
      v-model="commentaire"
      outlined
      counter="255"
      clearable
      clear-icon="cancel"
      dense
      maxlength="255"
      class="pt-5"
    />

    <v-row class="justify-center">
      <v-btn
        medium
        color="primary"
        style="text-transform: none;"
        class="white--text ml-8"
        :disabled="sending"
        @click="transmettreCommande('BROUILLON')"
      >Enregistrer la commande en brouillon</v-btn>

      <v-btn
        medium
        color="primary"
        style="text-transform: none;"
        class="white--text ml-8"
        :disabled="sending || isBoutonSoumettreActif"
        @click="transmettreCommande('EN_ATTENTE_TRAITEMENT')"
      >Transmettre la commande</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
export default {
  name: 'StepConfirmation',
  data() {
    return {
      commentaire: ' ',
      boutonTransmettreInactif: false,
      dateCommande: null,
      commandeFichierExcel: {},
      sending: false,
      clicSoumettre: null,
    }
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    isBoutonSoumettreActif() {
      if (
        this.$fmtTsEnDate(this.$store.getters.commande.tsCommande) >
        this.$fmtTsEnDate(new Date())
      ) {
        return true
      } else if (
        this.$fmtTsEnDate(this.$store.getters.commande.tsCommande) <=
        this.$fmtTsEnDate(new Date())
      ) {
        return false
      }
    },
  },

  watch: {
    // la creation de la commande suite import excel
    '$store.getters.commande.destinataireClient': function (
      destinataireClient
    ) {
      this.commentaire = this.$store.getters.commande.commentaire
    },
  },

  beforeMount() {
    this.clicSoumettre = 0
  },
  methods: {
    transmettreCommande(statutCommande) {
      console.log('transmettreCommande ')

      if (
        this.$store.getters.commande.destinataireClient.typeClient ==
        'PART_USAGE_PERSONNEL'
      ) {
        if (
          this.$store.getters.commande.destinataireClient.nom == null ||
          this.$store.getters.commande.destinataireClient.nomContact == null ||
          this.$store.getters.commande.destinataireClient.courrielContact ==
            null ||
          this.$store.getters.commande.destinataireClient.adresse == null ||
          this.$store.getters.commande.destinataireClient.ville == null ||
          this.$store.getters.commande.destinataireClient.codePostal == null ||
          this.$store.getters.commande.destinataireClient.noTelephone == null
        ) {
          this.$store.dispatch(
            'afficherWarning',
            'Toute les informations client doivent être saisies sauf le no de client si inconnu '
          )
          return
        }

        // Tout autre type de client
      } else {
        if (
          this.$store.getters.commande.destinataireClient.noClientJDE == null
        ) {
          this.$store.dispatch(
            'afficherWarning',
            'Veuillez inscrire un numéro de client'
          )
          return
        }
      }

      //Validations diverses

      if (
        this.$store.getters.commande.typeLivraison == null ||
        Object.keys(this.$store.getters.commande.typeLivraison).length == 0
      ) {
        this.$store.dispatch(
          'afficherWarning',
          'Un type de livraison doit être sélectionné'
        )
        return
      }

      if (
        this.$store.getters.commande.typeLivraison == 'LIVRAISON_SUCCURSALE' &&
        this.$store.getters.commande.succursaleLivraisonDemande == null
      ) {
        this.$store.dispatch(
          'afficherWarning',
          'Une succursale doit être sélectionnée'
        )
        return
      }

      if (
        this.$store.getters.commande.tsCommande < this.$fmtTsEnDate(new Date())
      ) {
        this.$store.dispatch(
          'afficherWarning',
          'La date de la commande ne peut etre inférieur à la date du jour'
        )
        return
      }

      if (this.$store.getters.commande.produits.length == 0) {
        this.$store.dispatch(
          'afficherWarning',
          'Il doit y avoir au minimum un produit dans la commande'
        )
        return
      }

      for (let i = 0; i < this.$store.getters.commande.produits.length; i++) {
        if (this.$store.getters.commande.produits[i].quantite == 0) {
          this.$store.dispatch(
            'afficherInfo',
            "Un des produits n'a pas de quantités de bouteilles"
          )
          return
        }

        if (this.$store.getters.commande.produits[i].quantite < 0) {
          this.$store.dispatch(
            'afficherInfo',
            'Un des produits a une quantité négative'
          )
          return
        }
      }

      if (this.$store.getters.commande.demandeur.nomContact == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Vous devez saisir un nom de contact'
        )
        return
      }

      if (this.$store.getters.commande.demandeur.courrielContact == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Vous devez saisir un courriel de contact'
        )
        return
      }

      if (this.$store.getters.commande.destinataireClient.nomContact == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Vous devez saisir un nom de contact pour le client'
        )
        return
      }

      if (
        this.$store.getters.commande.destinataireClient.courrielContact == null
      ) {
        this.$store.dispatch(
          'afficherWarning',
          'Vous devez saisir un courriel de contact pour le client'
        )
        return
      }

      //if (
      // this.$store.getters.commande.destinataireClient.courrielContact != null
      //  ) {
      //   var courriel = this.$store.getters.commande.destinataireClient
      //    .courrielContact
      //  var emailfilter = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/
      //  if (courriel != '' && !emailfilter.test(courriel.trim())) {
      //   this.$store.dispatch(
      //      'afficherInfo',
      //     "Le courriel n'est pas un courriel valide"
      //  )
      // return
      // }
      // }

      this.$store.getters.commande.statutCommande = statutCommande
      this.$store.getters.commande.commentaire = this.commentaire

      // Commande autre que Brouillon
      if (
        this.$store.getters.commande.statutCommande == 'EN_ATTENTE_TRAITEMENT'
      ) {
        this.$store.getters.commande.tsCommande = new moment().format(
          'YYYY-MM-DDTHH:mm:ss'
        )
      } else {
        // Commande en brouillon
        var dateJour = new Date()

        this.$store.getters.commande.tsCommande = moment(
          this.$store.getters.commande.tsCommande
        )
          .hour(dateJour.getHours())
          .minute(dateJour.getMinutes())
          .second(dateJour.getSeconds())

        this.$store.getters.commande.tsCommande = moment(
          this.$store.getters.commande.tsCommande
        ).format('YYYY-MM-DDTHH:mm:ss')
      }

      if (this.$route.params.copie == false) {
        this.transmettreCommandeCopie()
      } else {
        this.$store.getters.commande.destinataire =
          this.$store.getters.destinataire
        this.transmettreNouvelleCommande()
      }
    },

    transmettreCommandeCopie() {
      console.log('transmettreCommandeCopie ' + this.$store.getters.commande)
      this.sending = true

      axios
        .post(`/commandesip/majcommandeparagent`, this.$store.getters.commande)

        .then((response) => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.$store.dispatch('afficherSuccess', {
                texte:
                  'La commande no ' +
                  "<span style='font-size: 20px; font-weight-bold'>" +
                  this.$store.getters.commande.noCommande +
                  '</span>' +
                  ' est enregistrée avec succès',
                duree: 30,
              })
              this.$router.push({ name: 'accueil' })
              break
            case 'V007':
              this.$store.dispatch(
                'afficherWarning',
                "La commande n'a pas été enregistrée car l'agent n'est pas existant"
              )
              break
            case 'X001':
              this.$store.dispatch(
                'afficherWarning',
                "Pour utiliser un fichier Excel, cela doit être d'une nouvelle commande existante"
              )
              break
            case 'V014':
              this.$store.dispatch(
                'afficherWarning',
                "Vous n'avez pas l'autorisation d'effectuer une commande pour le compte de ce client. Veuillez communiquer avec ce dernier pour obtenir l'autorisation."
              )
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.sending = false
        })
    },

    transmettreNouvelleCommande() {
      console.log('transmettreNouvelleCommande')
      this.sending = true

      this.clicSoumettre++

      if (this.clicSoumettre == 1) {
        this.$store.getters.commande.premiereTransmission = true
      } else {
        this.$store.getters.commande.premiereTransmission = false
      }

      axios
        .post('/commandesip', this.$store.getters.commande)
        .then((response) => {
          let resp = response.data
          let msg = null

          switch (resp.codeRetour) {
            case 'OK':
              this.$store.dispatch('afficherSuccess', {
                texte:
                  'La commande no ' +
                  "<span style='font-size: 20px; font-weight-bold'>" +
                  resp.resultat.noCommande +
                  '</span>' +
                  ' est enregistrée avec succès',
                duree: 30,
              })

              this.$router.push({ name: 'accueil' })
              break
            case 'V007':
              this.$store.dispatch(
                'afficherWarning',
                "La commande n'a pas été enregistrée car l'agent n'est pas existant"
              )
              break
            case 'V014':
              this.$store.dispatch(
                'afficherWarning',
                "Vous n'avez pas l'autorisation d'effectuer une commande pour le compte de ce client. Veuillez communiquer avec ce dernier pour obtenir l'autorisation."
              )
              break
            case 'X001':
              this.$store.dispatch(
                'afficherWarning',
                "La commande ne peut être traitée pour l'instant"
              )
              break
            case 'V010':
              this.$store.getters.commande.produitsQuantiteInsuffisante =
                resp.resultat

              for (
                let i = 0;
                i < this.$store.getters.commande.produits.length;
                i++
              ) {
                // reset des valeurs
                this.$store.getters.commande.produits[
                  i
                ].indQuantiteEtInventaireSousUVC = false

                this.$store.getters.commande.produits[
                  i
                ].indQuantiteInvalideUVC = false

                this.$store.getters.commande.produits[
                  i
                ].indQuantiteRestanteModulo = false

                this.$store.getters.commande.produits[
                  i
                ].indMessageErreurAffiche = false

                for (
                  let j = 0;
                  j <
                  this.$store.getters.commande.produitsQuantiteInsuffisante
                    .length;
                  j++
                ) {
                  if (
                    this.$store.getters.commande.produits[i].noProduit ===
                    Number(
                      this.$store.getters.commande.produitsQuantiteInsuffisante[
                        j
                      ].produit
                    )
                  ) {
                    Vue.set(
                      this.$store.getters.commande.produits,
                      i,
                      this.$store.getters.commande.produits[i]
                    )

                    this.$store.getters.commande.produits[
                      i
                    ].quantiteInventaire =
                      this.$store.getters.commande.produitsQuantiteInsuffisante[
                        j
                      ].quantite

                    // Nouvelle partie pour gestion caisses incompletes
                    this.$store.getters.commande.produits[
                      i
                    ].indQuantiteEtInventaireSousUVC =
                      this.$store.getters.commande.produitsQuantiteInsuffisante[
                        j
                      ].indQuantiteEtInventaireSousUVC

                    this.$store.getters.commande.produits[
                      i
                    ].indQuantiteInvalideUVC =
                      this.$store.getters.commande.produitsQuantiteInsuffisante[
                        j
                      ].indQuantiteInvalideUVC

                    this.$store.getters.commande.produits[
                      i
                    ].indQuantiteRestanteModulo =
                      this.$store.getters.commande.produitsQuantiteInsuffisante[
                        j
                      ].indQuantiteRestanteModulo

                    this.$store.getters.commande.produits[i].quantiteModulo =
                      this.$store.getters.commande.produitsQuantiteInsuffisante[
                        j
                      ].quantiteModulo

                    this.$store.getters.commande.produits[
                      i
                    ].indMessageErreurAffiche =
                      this.$store.getters.commande.produitsQuantiteInsuffisante[
                        j
                      ].indMessageErreurAffiche
                  }
                }
              }

              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.sending = false
        })
    },
  },
}
</script>

<style scoped>
.theme--light.v-divider {
  border-color: grey !important;
}
</style>
